import { render, staticRenderFns } from "./DownloadAppShadow.vue?vue&type=template&id=988970f2&scoped=true"
import script from "./DownloadAppShadow.vue?vue&type=script&lang=js"
export * from "./DownloadAppShadow.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppShadow.vue?vue&type=style&index=0&id=988970f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988970f2",
  null
  
)

export default component.exports